import type { StructuredAddress, Transaction } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';

export type StructuredAddressProperty = keyof {
    [P in keyof Transaction as Transaction[P] extends StructuredAddress | undefined
        ? P
        : never]: any;
};
export const hasStructuredAddress =
    (field: StructuredAddressProperty): TransactionPredicate =>
    (transaction: Transaction) => {
        const value = transaction[field];
        return !!value && Object.values(value).some(Boolean);
    };
